module.exports = __webpack_public_path__ + "static/img/graymore_pictgrid6_800x769.43e94ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/graymore_pictgrid6_800x769.jpg
// module id = BxlR
// module chunks = 0